export default Object.freeze({
  FormTable: 1,
  DynamicEntity: 2,
  FormFieldAttachment: 3,
});
